enum CompetitiveInsightsMapOverlapTypeEnum {
  One = "1 Contract",
  Two = "2 Contracts",
  Three = "3 Contracts",
  Four = "4 Contracts",
  Five = "5 Contracts",
}

export { CompetitiveInsightsMapOverlapTypeEnum };
